module.exports = __webpack_public_path__ + "img/c2f58dc6cf374b79b3e2d0d343fdfe02.9aa599d7.jpg";